

<!--batch completed delivery tracking popup-->

<div class="modal-header">
  <div *ngIf="from=='DeleteConfirm'">
<h4 class="modal-title" id="modal-basic-title">{{'shipment.confirmation' | cxTranslate}}</h4>
  </div>
  <div *ngIf="from=='forgotpassword'">
<h4 class="modal-title" id="modal-basic-title">{{'home.forgotPassword.alternateuse' | cxTranslate}}</h4>
  </div>
    
    <i class="fa fa-times close-icon" aria-hidden="true" (click)="closeModal()"></i>
</div>
<div class="modal-body">
  <h6 class="text-black " *ngIf="from=='DeleteConfirm'">{{'shipment.deleteattatchment' | cxTranslate}}</h6>
  <span class="text-black " *ngIf="from=='forgotpassword'">{{'home.forgotPassword.alternateEmailMessage' | cxTranslate}}</span>


</div>
<div class="modal-footer">
  <div *ngIf="from=='DeleteConfirm'">
    <button type="button" class="btn btn-primary" (click)="YesClicked()">{{'shipment.yes' | cxTranslate}}</button>
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">{{'shipment.no' | cxTranslate}}</button>
  </div>
  <div *ngIf="from=='forgotpassword'">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">{{'home.productHeader.Close' | cxTranslate }}</button>
  </div>

</div>



